export const replaceExtraCharacters = (word: string) => {
  return word?.replace(/-data|-electric/g, '').toUpperCase() ?? null;
};
